<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">抢购</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <div class="change">
          状态筛选：
          <el-select v-model="params.status" @change="getProjectList({page:1})" placeholder="请选择">
            <el-option
              v-for="k in Object.keys(statusTypes)"
              :key="k"
              :label="statusTypes[k]"
              :value="k"
            >{{statusTypes[k]}}</el-option>
          </el-select>
        </div>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import Create from "./components/create";
import List from "./components/list";
import { STATUS_TYPES } from "./constants";

export default {
  name: "orderTaskProject",
  data() {
    return {
      params: {
        status: "0"
      },
      statusTypes: STATUS_TYPES,
      options: [
        {
          value: "1",
          label: "邀请额度"
        },
        {
          value: "2",
          label: "USDT额度"
        },
        {
          value: "3",
          label: "FBS额度"
        },
        {
          value: "4",
          label: "全部额度"
        }
      ]
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState("orderTaskProject", ["pagination"])
  },
  methods: {
    ...mapActions("orderTaskProject", [
      "getList",
      "getCoinTypeList",
      "freshData"
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...this.pagination,
        ...this.params,
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = "";
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
